import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService, BASE_URL_API } from '../../../app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssignStudentCoursesService extends AppService{

  constructor(http: HttpClient) {
    super(http);
  }

  GetAll<T>(stu_bi_id:number): Observable<any> {
    this.endpoint = `${BASE_URL_API}/assign/${stu_bi_id}`;
    return this.get(this.endpoint);
  }
  
  Insert<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/assign`;
    return this.post(this.endpoint, datos);
  }
  Update<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/assign`;
    return this.put(this.endpoint, datos);
  }
  Delete<T>(stu_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/assign/${stu_bi_id}`;
    return this.delete(this.endpoint);
  }
}
